import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, serchSelect, Kamitaku } from "@/mixins/index";
import { rUserMailData } from "@/api/kamitaku/kamitaku";
export default {
  name: "kanitakuRUser",
  mixins: [tabulation, serchSelect, Kamitaku],
  data: function data() {
    return {
      reqFn: rUserMailData,
      searchData: {
        r: 1
      },
      tableData: [],
      Dynamic: [],
      totalDynamic: [],
      totalDynamicValue: [],
      packingHandle: this.debounce(this.heavy, 500, false),
      Rlist: [{
        label: this.$t('rSmall'),
        value: 1
      }, {
        label: this.$t('rMedium'),
        value: 2
      }, {
        label: this.$t('rLarge'),
        value: 3
      }, {
        label: this.$t('rZeroRecharge'),
        value: 4
      }, {
        label: this.$t('rAll'),
        value: 5
      }]
    };
  },
  created: function created() {},
  methods: {
    getListnew: function getListnew() {
      var _this = this;

      this.reqLoading = true;
      this.searchData = _objectSpread(_objectSpread({}, this.searchData), this.defaultData());
      this.getList( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
          var list, DynamicList, keys, total_key, _loop, key;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.reqLoading = false;
                  list = [];
                  DynamicList = [];

                  if (!(!res || !res.taskData)) {
                    _context.next = 5;
                    break;
                  }

                  return _context.abrupt("return");

                case 5:
                  keys = Object.keys(res.taskData);
                  total_key = res.taskData;
                  keys.sort(function (a, b) {
                    var partsA = a.split('-').map(Number);
                    var partsB = b.split('-').map(Number);

                    for (var i = 0; i < Math.max(partsA.length, partsB.length); i++) {
                      var numA = partsA[i] || 0;
                      var numB = partsB[i] || 0;

                      if (numA > numB) {
                        return -1;
                      } else if (numA < numB) {
                        return 1;
                      }
                    }

                    return 0;
                  });
                  keys = keys.reverse();

                  _loop = function _loop(key) {
                    var data = {
                      date: key,
                      TimeStamp: new Date(key).getTime()
                    };
                    var newList = [];
                    keys.forEach(function (key1) {
                      var checkpoint = total_key[key1];
                      var index = res.data[key].findIndex(function (i) {
                        return i.task == key1;
                      });
                      console.log(res.data[key][index]);
                      data['n' + key1] = index > -1 ? res.data[key][index].user_count : 0;
                      newList.push({
                        label: checkpoint,
                        value: 'n' + key1
                      });
                    });
                    DynamicList = newList.length > DynamicList.length ? newList : DynamicList;

                    _this.tableData.push(data);
                  };

                  for (key in res.data) {
                    _loop(key);
                  }

                  _this.Dynamic = [];
                  _this.tableData = _this.tableData.sort(function (a, b) {
                    return a['TimeStamp'] - b['TimeStamp'];
                  });
                  setTimeout(function () {
                    _this.totalDynamic = DynamicList;
                    _this.Dynamic = DynamicList;
                    _this.totalDynamicValue = DynamicList.map(function (i) {
                      return i.value;
                    });

                    _this.$nextTick(function () {
                      _this.getTableRight();
                    });
                  }, 50);

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    totalDynamicChange: function totalDynamicChange(e) {
      var list = [];
      this.isShow = false;
      this.totalDynamic.forEach(function (item, index) {
        e.forEach(function (items, indexs) {
          if (item.value == items) {
            list.push(item);
          }
        });
      });
      this.packingHandle(list);
    },
    debounce: function debounce(func, wait, immediate) {
      var timeout = null;
      return function () {
        var context = this;
        var args = arguments;
        if (timeout) clearTimeout(timeout);

        if (immediate) {
          var callNow = !timeout;
          timeout = setTimeout(function () {
            timeout = null;
          }, wait);
          if (callNow) func.apply(context, args);
        } else {
          timeout = setTimeout(function () {
            func.apply(context, args);
          }, wait);
        }
      };
    },
    // 重设列表
    heavy: function heavy(e) {
      var _this2 = this;

      this.isShow = false;
      this.Dynamic = [];
      setTimeout(function () {
        _this2.Dynamic = e;
        _this2.isShow = true;
      }, 100);
    },
    exportdata: function exportdata() {
      var d = {};
      var columns = [{
        label: this.$t('date'),
        prop: 'date'
      }];
      var data = [];
      this.Dynamic.map(function (item) {
        columns.push({
          label: item.label,
          prop: item.value
        });
        d[item.value] = 0;
      });
      this.tableData.forEach(function (item) {
        var s = _objectSpread(_objectSpread({}, d), {}, {
          register_num: item.register_num
        });

        for (var key in s) {
          s[key] = item[key];
        }

        s.date = item.date;
        data.push(s);
      });
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};